module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Bill of Lading")])], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": this.finalPlaceUSNONUS[0].allModuleId ?
        this.finalPlaceUSNONUS[0].allModuleId :
        '',
      "jobSeriesBanner": this.finalPlaceUSNONUS[0].ffExportFclConsoSeries ?
        this.finalPlaceUSNONUS[0].ffExportFclConsoSeries :
        '',
      "bannerClientName": this.clientName ? this.clientName : '',
      "trackingId": _vm.trackingId != '' ? _vm.trackingId : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.conBLtable.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('label', {
    staticClass: "box-title"
  }, [_c('u', [_vm._v("Client Container Details")])]), _vm._v(" "), _c('Filter-Agency-Modal'), _vm._v(" "), _c('FilterCBModal'), _vm._v(" "), _c('ClientCard'), _vm._v(" "), _c('ShipmentTrackCard'), _vm._v(" "), (_vm.consobillLandingModel.blType == 'LinerBL') ? _c('b-button', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.sendMANIFESTATION
    }
  }, [_vm._v("SEND MANIFESTATION DETAILS")]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-5"
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', [_vm._v("MBL Release Date")]), _c('br'), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('date-picker', {
    staticClass: "mt-2",
    style: ({
      width: '500px'
    }),
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "mbl_release_date",
      "id": "mbl_release_date"
    },
    model: {
      value: (_vm.billLandingModel.mbl_release_date),
      callback: function($$v) {
        _vm.$set(_vm.billLandingModel, "mbl_release_date", $$v)
      },
      expression: "billLandingModel.mbl_release_date"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', [_vm._v("MBL Date")]), _c('br'), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('date-picker', {
    staticClass: "mt-2",
    style: ({
      width: '500px'
    }),
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "mbl_date",
      "id": "mbl_date"
    },
    model: {
      value: (_vm.billLandingModel.mbl_date),
      callback: function($$v) {
        _vm.$set(_vm.billLandingModel, "mbl_date", $$v)
      },
      expression: "billLandingModel.mbl_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "clientSB"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Container No.")]), _vm._v(" "), _c('th', [_vm._v("Container Type")]), _vm._v(" "), _c('th', [_vm._v("Shipping Bill No.")]), _vm._v(" "), _c('th', [_vm._v("Shipping Bill Date")]), _vm._v(" "), _c('th', [_vm._v("Custom Seal No")]), _vm._v(" "), _c('th', [_vm._v("Line Seal No")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.conBLtable), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.clientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.fclConcontainerNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.containerType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.SBNo))]), _vm._v(" "), _c('td', _vm._l((item.SBDate), function(itemDate, index) {
      return _c('span', {
        key: index
      }, [_vm._v(_vm._s(_vm._f("moment")(itemDate)) + "\n                        " + _vm._s(index != Object.keys(item.SBDate).length - 1 ? "," : ""))])
    })), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.customSealNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.lineSealNo))])])
  }))])])], 1) : _vm._e(), _vm._v(" "), (_vm.clientList.length > 0 || _vm.consobillLandingModel.conblLandingId != '') ? _c('div', [_c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [(_vm.consobillLandingModel.conblLandingId == '') ? _c('label', {
    attrs: {
      "for": "fclConsoMultipleClientId"
    }
  }, [_vm._v("Client Name")]) : _vm._e(), _vm._v(" "), (_vm.consobillLandingModel.conblLandingId == '') ? _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "fclConsoMultipleClientId",
      "option-value": "fclConsoMultipleClientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.consobillLandingModel.fclConsoMultipleClientId),
      callback: function($$v) {
        _vm.$set(_vm.consobillLandingModel, "fclConsoMultipleClientId", $$v)
      },
      expression: "consobillLandingModel.fclConsoMultipleClientId"
    }
  }) : _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "fclConsoMultipleClientId"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.consobillLandingModel.clientName),
      callback: function($$v) {
        _vm.$set(_vm.consobillLandingModel, "clientName", $$v)
      },
      expression: "consobillLandingModel.clientName"
    }
  })], 1), _vm._v(" "), (!_vm.consobillLandingModel.fclConsoMultipleClientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorVgmList.fclConsoMultipleClientId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("B/L Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.blTypeList,
      "option-value": "blTypeVal",
      "option-text": "blTypeTxt",
      "placeholder": "Select B/L Type",
      "isDisabled": _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ? false : _vm.consobillLandingModel.conblLandingId != '' ||
        _vm.blTableArray.length > 0 ?
        true :
        false
    },
    model: {
      value: (_vm.consobillLandingModel.blType),
      callback: function($$v) {
        _vm.$set(_vm.consobillLandingModel, "blType", $$v)
      },
      expression: "consobillLandingModel.blType"
    }
  }), _vm._v(" "), (!_vm.consobillLandingModel.blType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorVgmList.blType))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.consobillLandingModel.blType == 'LinerBL') ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "frghtTermsLiner"
    }
  }, [_vm._v("Liner Freght Terms")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.frghtTermsLinerListName,
      "option-value": "frghtTermsLinerVal",
      "option-text": "frghtTermsLinerTxt",
      "placeholder": "Select Freght Terms"
    },
    model: {
      value: (_vm.consobillLandingModel.frghtTermsLiner),
      callback: function($$v) {
        _vm.$set(_vm.consobillLandingModel, "frghtTermsLiner", $$v)
      },
      expression: "consobillLandingModel.frghtTermsLiner"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.consobillLandingModel.blType == 'HouseBL') ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "frghtTermsHbl"
    }
  }, [_vm._v("Freght Terms for HBL")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.frghtTermsHblList,
      "option-value": "frghtTermsHblVal",
      "option-text": "frghtTermsHblTxt",
      "placeholder": "Select Freght Terms for HBL"
    },
    model: {
      value: (_vm.consobillLandingModel.frghtTermsHbl),
      callback: function($$v) {
        _vm.$set(_vm.consobillLandingModel, "frghtTermsHbl", $$v)
      },
      expression: "consobillLandingModel.frghtTermsHbl"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.consobillLandingModel.blType == 'HouseBL') ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "frghtTermsMbl"
    }
  }, [_vm._v("Freght Terms for MBL")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.frghtTermsMblList,
      "option-value": "frghtTermsMblVal",
      "option-text": "frghtTermsMblTxt",
      "placeholder": "Select Freght Terms for MBL"
    },
    model: {
      value: (_vm.consobillLandingModel.frghtTermsMbl),
      callback: function($$v) {
        _vm.$set(_vm.consobillLandingModel, "frghtTermsMbl", $$v)
      },
      expression: "consobillLandingModel.frghtTermsMbl"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.consobillLandingModel.blType == 'LinerBL') ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Master B/L Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "linerBLNumber",
      "name": "linerBLNumber",
      "disabled": _vm.consobillLandingModel.conblLandingId != '' ||
        _vm.blTableArray.length > 0 ?
        true :
        false
    },
    model: {
      value: (_vm.consobillLandingModel.linerBLNumber),
      callback: function($$v) {
        _vm.$set(_vm.consobillLandingModel, "linerBLNumber", $$v)
      },
      expression: "consobillLandingModel.linerBLNumber"
    }
  })], 1), _vm._v(" "), (!_vm.consobillLandingModel.linerBLNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorlinerBLNumber))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.consobillLandingModel.blType == 'LinerBL') ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload Liner B/L")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "name": "linerBLupload",
      "id": "linerBLupload",
      "disabled": _vm.consobillLandingModel.conblLandingId != '' ||
        _vm.blTableArray.length > 0 ?
        true :
        false,
      "multiple": ""
    },
    on: {
      "selected": _vm.onFileChangelinerBL
    },
    model: {
      value: (_vm.consobillLandingModel.linerBLupload),
      callback: function($$v) {
        _vm.$set(_vm.consobillLandingModel, "linerBLupload", $$v)
      },
      expression: "consobillLandingModel.linerBLupload"
    }
  })], 1), _vm._v(" "), (!_vm.consobillLandingModel.linerBLupload) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorlinerBLupload))]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.uploadBookingStatus.length > 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }), _vm._v(" "), _vm._l((_vm.uploadBookingStatus), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "15"
      }
    }, [_c('a', {
      attrs: {
        "href": (this.docURL) + "/LinerBLCon/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))])])
  })], 2) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "billingParty"
    }
  }, [_vm._v("Billing Party")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.billingPartyList,
      "option-value": "billingPartyVal",
      "option-text": "billingPartyTxt",
      "placeholder": "Select Billing Party"
    },
    model: {
      value: (_vm.consobillLandingModel.billingParty),
      callback: function($$v) {
        _vm.$set(_vm.consobillLandingModel, "billingParty", $$v)
      },
      expression: "consobillLandingModel.billingParty"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "billingParty"
    }
  }, [_vm._v("Billing Type : "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-radio-group', {
    staticClass: "mt-3",
    attrs: {
      "options": _vm.billingTypeList,
      "value-field": "BTVal",
      "text-field": "BTText",
      "disabled-field": "notEnabled"
    },
    model: {
      value: (_vm.consobillLandingModel.billingType),
      callback: function($$v) {
        _vm.$set(_vm.consobillLandingModel, "billingType", $$v)
      },
      expression: "consobillLandingModel.billingType"
    }
  }), _vm._v(" "), (!_vm.consobillLandingModel.billingType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorVgmList.billingType))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.consobillLandingModel.billingParty == 'OthersSpecify') ? _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Other Specify")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "otherSpecBillingParty",
      "name": "otherSpecBillingParty"
    },
    model: {
      value: (_vm.consobillLandingModel.otherSpecBillingParty),
      callback: function($$v) {
        _vm.$set(_vm.consobillLandingModel, "otherSpecBillingParty", $$v)
      },
      expression: "consobillLandingModel.otherSpecBillingParty"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('b-button', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-info",
      "id": "addButtonLoaderCB"
    },
    on: {
      "click": _vm.addBLLanding
    }
  }, [_vm._v(_vm._s(_vm.consobillLandingModel.conblLandingId == "" ? "Add" : "Edit") + "\n                  Client BL")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderCB"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.blTableArray.length > 0) ? _c('hr', {
    staticClass: "hr-border"
  }) : _vm._e(), _vm._v(" "), (_vm.blTableArray.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('label', {
    staticClass: "box-title"
  }, [_c('u', [_vm._v("Client BL Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "clientBl"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("BL Type")]), _vm._v(" "), (_vm.consobillLandingModel.blType == 'LinerBL') ? _c('th', [_vm._v("\n                      Proceed to Invoice\n                    ")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Delete")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.blTableArray), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.viewEditBL(item, index)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(item.clientName) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.blType))]), _vm._v(" "), (_vm.consobillLandingModel.blType == 'LinerBL') ? _c('td', [_c('md-button', {
      staticClass: "md-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.proceedToTallyByClient(
            item.conblLandingId,
            item.InvTallyId,
            item.clientName
          )
        }
      }
    }, [_vm._v("\n                        Invoice\n                      ")])], 1) : _vm._e(), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.removeCommon(item)
        }
      }
    }, [_c('md-icon', [_vm._v("delete_sweep")])], 1)], 1)])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.clientList.length == 0) ? _c('md-layout', {
    staticClass: "mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader1"
    },
    on: {
      "click": _vm.proceedNewBL
    }
  }, [_vm._v(_vm._s(_vm.consobillLandingModel.blType == "LinerBL" ?
    "Save & Proceed to AMS Filing" :
    " Save & Proceed to BL (Draft)"))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopBL",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.oncloseBL
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "delete",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseBLData
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60fb677e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ffExportCon/conFclBLofLanding.vue
// module id = 2677
// module chunks = 0